var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlechita(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99864 5.94724C5.99234 5.84603 5.95236 5.74983 5.88506 5.67396L1.79607 1.13112C1.68716 1.00945 1.52152 0.955277 1.36175 0.989076C1.20199 1.02287 1.07248 1.13949 1.02218 1.29484C0.971889 1.45018 1.00848 1.62056 1.11813 1.74157L4.9338 5.97919L1.11813 10.2168C1.00848 10.3378 0.971887 10.5082 1.02218 10.6635C1.07248 10.8189 1.20199 10.9355 1.36175 10.9693C1.52152 11.0031 1.68716 10.9489 1.79607 10.8273L5.88506 6.28441C5.96718 6.19213 6.00819 6.0704 5.99864 5.94724Z",
    fill: "#BFBFBF",
    stroke: "#BFBFBF",
    strokeWidth: 1.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechita);
export default __webpack_public_path__ + "static/media/flechita.e419d8c93e852173b9b8261835467277.svg";
export { ForwardRef as ReactComponent };